
import React, { useState } from "react";

export type ApprovalDiagnosticsPanelProps = {
  defaultApprovalFlowId?: string;
};

export function ApprovalDiagnosticsPanel(props: ApprovalDiagnosticsPanelProps) {
  const [approvalFlowId, setApprovalFlowId] = useState(props.defaultApprovalFlowId ?? "");

  return (
    <div style={{ padding: 12, border: "1px solid rgba(255,255,255,0.12)", borderRadius: 12 }}>
      <div style={{ fontWeight: 700, marginBottom: 8 }}>Approval Diagnostics (Stub)</div>
      <div style={{ fontSize: 12, color: '#aaa' }}>
        This component is a placeholder for single-flow diagnostics. Use the Repair Tab for batch processing.
      </div>
    </div>
  );
}

export default ApprovalDiagnosticsPanel;
